<template>
  <div>
    <div v-if="Object.values(formProps).length === 0" id="noData">
      <div class="has-text-centered is-flex is-align-center is-justify-center">
        <p class="has-text-grey is-size-4 th is-padding-x-s is-margin-top-s">
          ***
        </p>
        <p class="has-text-grey is-size-6 th is-padding-x">
          {{ $t("form.notFound") }}
        </p>
        <p class="has-text-grey is-size-4 th is-padding-x-s is-margin-top-s">
          ***
        </p>
      </div>
    </div>
    <div v-else>
      <FormMange
        v-if="renderComponent === true"
        :tab="false"
        :formProps="formProps"
        :startupIdProps="this.user._id"
        :batchData="batch"
        :demo="false"
        :isLockForm="isLockForm"
      />
    </div>

    <CustomizingTour name="tourForm" :steps="stepForm" />
  </div>
</template>
<script>
import { HTTP, HTTPDynamic } from "../axios";
import FormMange from "./form/FormMange";

import momentTH from "moment/src/locale/th";
import moment from "moment";
import { stepForm } from "../guide/form";
import CustomizingTour from "../guide/CustomizingTour";

export default {
  components: {
    FormMange,
    CustomizingTour,
  },
  data() {
    return {
      stepForm: stepForm,
      formProps: {},
      renderComponent: false,
      isLockForm: false,
      tourOptions: {
        labels: {
          buttonSkip: "ข้าม",
          buttonPrevious: "ก่อนหน้า",
          buttonNext: "ต่อไป",
          buttonStop: "สิ้นสุด",
        },
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    batch() {
      return this.$store.state.batch;
    },
    user() {
      return this.$store.state.user;
    },
    modalActive() {
      return this.$store.state.modalActive;
    },
  },
  async mounted() {
    await this.fethFormBatch();
    this.fetchStatusLockFoem();
  },
  destroyed() {
    if (typeof this.$tours["tourForm"] !== "undefined") {
      this.$tours["tourForm"].stop();
    }
  },
  methods: {
    setTour() {
      let filter = stepForm.filter(
        (filter) => filter.target !== "#form-goto-form"
      );
      this.stepForm = filter;

      if (
        (typeof this.$tours.tourFormGo === "undefined" ||
          this.$tours.tourFormGo.currentStep === -1) &&
        (typeof this.$tours.tourInfo === "undefined" ||
          this.$tours.tourInfo.currentStep === -1) &&
        (typeof this.$tours.tourBusinessInfo === "undefined" ||
          this.$tours.tourBusinessInfo.currentStep === -1) &&
        (typeof this.$tours.tourPruductInfo === "undefined" ||
          this.$tours.tourPruductInfo.currentStep === -1) &&
        this.modalActive === false
      ) {
        this.$tours["tourForm"].start();
      }
    },
    async fethFormBatch() {
      let data = {
        batchId: this.batch._id,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post(`get/form/on/batch`, data)
        .then((res) => {
          // console.log("get/form/on/batch", res);
          if (res.data.success) {
            if (res.data.obj.listComponents.length !== 0) {
              if (
                res.data.obj.listComponents[0].componentId.type === "template"
              ) {
                this.fetchTmp(res.data.obj.listComponents[0].componentId.id);
              } else {
                this.fethForm(res.data.obj.listComponents[0].componentId.id);
              }
              if (this.modalActive === false) {
                setTimeout(() => {
                  this.setTour();
                }, 6000);
              }
            } else {
              this.isLoadingPage = false;
              this.formProps = {};
            }
          } else {
            this.formProps = {};
            this.isLoadingPage = false;
          }
        })
        .catch((e) => {
          this.isLoadingPage = false;
          console.log("get/form/on/batch/error", e);
        });
    },
    async fethForm(id) {
      let arr = [];
      arr[0] = id;
      let data = {
        components: arr,
      };
      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post(`get/component/by/id`, data)
        .then((res) => {
          //  console.log("get/component/by/id", res);
          if (res.data.success) {
            if (typeof res.data.obj.form[0] !== "undefined") {
              let obj = {
                components: res.data.obj.form[0].components,
                name: res.data.obj.form[0].name,
                _id: res.data.obj.form[0]._id,
                type: "component",
              };
              this.formProps = obj;
            } else {
              this.formProps = {};
            }
          } else {
            this.formProps = [];
          }
          this.renderComponent = true;
        })
        .catch((e) => {
          this.renderComponent = true;
          console.log("get/component/by/id/error", e);
        });
    },
    async fetchTmp(id) {
      let data = {
        templateId: id,
      };

      HTTPDynamic.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTPDynamic.post(`get/template/by/id`, data)
        .then((res) => {
          //  console.log("get/template/by/id", res);
          if (res.data.success) {
            this.formProps =
              typeof res.data.obj !== "undefined" ? res.data.obj : {};
          } else {
            this.formProps = {};
          }
          this.renderComponent = true;
        })
        .catch((e) => {
          this.renderComponent = true;
          console.log("get/template/by/id/error", e);
        });
    },
    async fetchStatusLockFoem() {
      let data = {
        companyId: this.user._id,
        batchId: this.batch._id,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post(`api/check/is/lock/data/form`, data)
        .then((res) => {
          //  console.log("api/check/is/lock/data/form", res);
          if (res.data.success) {
            this.isLockForm = res.data.obj.isLockForm;
          }
        })
        .catch((e) => {
          console.log("api/check/is/lock/data/form/error", e);
        });
    },
  },
};
</script>
<style scoped>
#boxForm {
  min-height: 570px !important;
  padding: 40px 50px 40px 10px !important;
}
.breadcrumbs-tab:hover {
  color: #6d8df3 !important;
}
.btn-form-add {
  min-width: 130px;
  min-height: 40px;
  border: 1px solid #6d8df3;
  color: #6d8df3;
  margin: 5px;
}
.marginLogo {
  margin: 25px 5px;
}
.border-bt {
  border-bottom: 1px solid black;
  margin: 10px;
}
.detailsHeader {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 25px;
}
.centeralignment {
  display: flex;
  justify-content: center;
  text-align: center;
}
.flexDate {
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: flex-end;
  width: 100%;
  margin-left: 5px;
}
.flexMg {
  display: flex;
  margin: 0 15px;
}
</style>
